import { render, staticRenderFns } from "./UpcomingVolunteeringDialog.vue?vue&type=template&id=423eb948"
import script from "./UpcomingVolunteeringDialog.vue?vue&type=script&lang=js"
export * from "./UpcomingVolunteeringDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports